import { fitBounds } from 'google-map-react';

export const findBounds = (positions, width, height, zoom) => {

  let center = {
    lat: 54.501280,
    lng: -1.477420,
  }

  // let zoom = 5;

  const map_size = {
    width: width,
    height: height,
  };

  if (positions.length > 0) {
    let max_long = parseFloat(positions[0].coordinates.longitude);
    let max_lat = parseFloat(positions[0].coordinates.latitude);
    let min_long = parseFloat(positions[0].coordinates.longitude);
    let min_lat = parseFloat(positions[0].coordinates.latitude);

    positions.forEach(position => {
      max_long = parseFloat(position.coordinates.longitude) > max_long? parseFloat(position.coordinates.longitude) : max_long;
      max_lat = parseFloat(position.coordinates.latitude) > max_lat? parseFloat(position.coordinates.latitude) : max_lat;
      min_long = parseFloat(position.coordinates.longitude) < min_long? parseFloat(position.coordinates.longitude) : min_long;
      min_lat = parseFloat(position.coordinates.latitude) < min_lat? parseFloat(position.coordinates.latitude) : min_lat;
    });


    let center_long = (max_long + min_long) / 2;
    let center_lat = (max_lat + min_lat) / 2;

    let bounds = {};

    bounds = {
      ne: {
        lat: max_lat,
        lng: max_long
      },
      sw: {
        lat: positions.length > 1? min_lat - 0.00001 : min_lat - 0.00001,
        lng: positions.length > 1? min_long - 0.00001 : min_long - 0.00001
      }
    }

    let result = fitBounds(bounds, map_size);
    center = result.center;
    // console.log("Zoom is ", zoom);
    zoom = result.zoom > 22? 22 : result.zoom;
    if (positions.length == 1){
      zoom = 18;
    }
    // console.log("Zoom is ", zoom);
  }

  return {
    center,
    zoom,
  }
}